
















import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class Stepper extends Vue {
  @Prop({default: 1}) currentStep: number;
}
